import { ComponentProps, FC } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  selectIsNeedAfterRegistrationForm,
  selectUserDetails,
} from "../../../../../store/selectors/profile";
import { selectLogo } from "../../../../../store/selectors/layout";
import EventsTrackWrapperClick from "../../../EventsTrack/wrappers/EventsTrackWrapperClick";
import Logo from "../../../Header/Logo/Logo";
import ProfilePic from "../../../../presentational/ProfilePic/ProfilePic";
import styles from "./AppModalPhoneHeader.module.scss";

type Props = Partial<Pick<ComponentProps<typeof Logo>, "onLogoClick">> & {
  showProfile?: boolean;
};

const AppModalPhoneHeader: FC<Props> = ({
  onLogoClick,
  showProfile = true,
}) => {
  const currentUser = useSelector(selectUserDetails);
  const logo = useSelector(selectLogo);
  const isNeedAfterRegistrationForm = useSelector(
    selectIsNeedAfterRegistrationForm
  );
  const canShowUser = () =>
    currentUser?.loggedIn && !isNeedAfterRegistrationForm && showProfile;

  return (
    <div className={styles["modal-phone-header"]}>
      <EventsTrackWrapperClick id={23}>
        <Logo onLogoClick={onLogoClick} options={logo} />
      </EventsTrackWrapperClick>

      {canShowUser() && (
        <EventsTrackWrapperClick id={24}>
          <Link to="/profile" className={styles.profile}>
            <ProfilePic imageId={currentUser?.pictureId} />
          </Link>
        </EventsTrackWrapperClick>
      )}
    </div>
  );
};

export default AppModalPhoneHeader;
